import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
	},
	{
		path: '/about-us',
		name: 'about-us',
		component: () => import('../views/AboutUs.vue'),
	},
	{
		path: '/business',
		name: 'business',
		component: () => import('../views/Business.vue'),
	},
	{
		path: '/new-list',
		name: 'new-list',
		component: () => import('../views/NewList.vue'),
	},
	{
		path: '/new-detail',
		name: 'new-detail',
		component: () => import('../views/NewDetail.vue'),
	},
	{
		path: '/goods-list',
		name: 'goods-list',
		component: () => import('../views/GoodsList.vue'),
	},
	{
		path: '/contact',
		name: 'contact',
		component: () => import('../views/Contact.vue'),
	},
];
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};
const router = new VueRouter({
	routes,
});

export default router;
